import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { FIELDS } from './useDragDropRecipients.constants'
import {
  getDraggableItemId,
  getSourceFieldIdFromActive,
  isValidDestination,
} from './useDragDropRecipients.utils'

export function useDragDropRecipients() {
  const { setFieldValue, values } = useFormikContext()

  const { t } = useTranslation()

  const [errorDrop, setErrorDrop] = useState(null)

  function handleDragEnd(event) {
    const activeId = event?.active?.id
    const overId = event?.over?.id

    setErrorDrop(null)

    if (!isValidDestination(event)) {
      return
    }

    const destinationId = String(overId)
    const sourceId = getSourceFieldIdFromActive(event.active)

    if (!FIELDS.includes(destinationId) || !FIELDS.includes(sourceId)) {
      return
    }

    if (destinationId === sourceId) {
      return
    }

    const itemId = getDraggableItemId(activeId)

    if (values[destinationId]?.find(i => i.value.toString() === itemId)) {
      return
    }

    const value = values[sourceId]?.find(i => i.value.toString() === itemId)

    if (!value) {
      return
    }

    setFieldValue(
      sourceId,
      values[sourceId].filter(i => i.value.toString() !== itemId)
    )
    setFieldValue(destinationId, [...values[destinationId], value])
  }

  function handleDragOver(event) {
    const activeId = event?.active?.id
    const overId = event?.over?.id

    if (!isValidDestination(event)) {
      setErrorDrop(null)

      return
    }

    const destinationId = String(overId)
    const itemId = getDraggableItemId(activeId)

    if (values[destinationId]?.find(i => i.value.toString() === itemId)) {
      if (!errorDrop) {
        setErrorDrop(t('Error.DragDropSameValue'))
      }
    } else {
      setErrorDrop(null)
    }
  }

  return { errorDrop, handleDragEnd, handleDragOver }
}
